import { OrbitControls, useProgress, Html } from "@react-three/drei"
import { Canvas } from "@react-three/fiber"
import { Suspense } from "react"
import "./DustShaderMaterial"
import "./GateShaderMaterial"
import "./MonitorShaderMaterial"
// import { EffectComposer, Bloom } from "@react-three/postprocessing"
import Stargate from "./Stargate"

export default function App() {
    return (
        <div className="App">
            <Canvas flat={false} camera={{ position: [5, 6, 14] }} shadows>
                <color attach="background" args={["black"]} />
                <mesh rotation={[-Math.PI / 2, 0, 0]} scale={100} position={[0, -1, 0]}>
                    <planeGeometry />
                    <meshBasicMaterial color="#111" />
                </mesh>
                <Suspense fallback={<Loader />}>
                    <Stargate />
                </Suspense>
                <OrbitControls />
            </Canvas>
        </div>
    )
}

function Loader() {
    const { progress } = useProgress()
    return (
        <Html center>
            <h3 style={{ color: "white" }}>{progress} % loaded</h3>
        </Html>
    )
}
